module.exports = __webpack_public_path__ + "static/media/winner_2.9998518d.png";